<template>
  <div
    v-if="fieldObj.fieldInfo.fieldExtraType == 10"
    class="style1 align-left"
    :class="{
      err: fieldObj.dirty && fieldObj.invalid
    }"
  >
    <a-checkbox class="u-policy-container" @change="handleChange" :disabled="fieldObj.disabled" v-model="fieldObj.isSelected">
      <div class="u-policy-box" :class="policyClass()" v-html="fieldObj.privacyPolicyTitle"></div>
    </a-checkbox>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
  <div
    v-else
    class="style1"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid,
      statusNoBorder: fieldStyle == 'style2'
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-radio-list">
      <a-radio
        v-for="(o, i) in fieldObj.listOptions"
        :key="o.optionId"
        class="m-radio-item"
        :class="{
          'has-desc':
            fieldObj.options &&
            fieldObj.options[i] &&
            (fieldObj.options[i].optionDescText ||
              fieldObj.options[i].optionDescHrefText)
        }"
        @change="onChange"
        :value="o.optionId"
        :disabled="fieldObj.disabled || o.disabled"
        :checked="fieldObj.model.optionId == o.optionId"
      >
        {{ o.optionValue }}
        <input
          class="otherInput"
          v-if="o.otherisFillIn == 1"
          :disabled="fieldObj.model.optionId != o.optionId"
          type="text"
          v-model="o.otherValue"
          @blur="inputBlur($event, o)"
        />
        <div
          v-if="
            fieldObj.options &&
              fieldObj.options[i] &&
              fieldObj.options[i].optionDescText
          "
          class="u-desc"
        >
          {{ fieldObj.options[i].optionDescText }}
        </div>
        <div
          v-if="
            fieldObj.options &&
              fieldObj.options[i] &&
              fieldObj.options[i].optionDescHrefText
          "
          class="u-desc"
        >
          <a :href="fieldObj.options[i].optionDescHref">{{
            fieldObj.options[i].optionDescHrefText
          }}</a>
        </div>
        <div
          class="u-reg-err-tips"
          v-if="
            o.checked &&
              o.otherisFillIn == 1 &&
              o.otherIsRequire == 1 &&
              !o.otherValue
          "
        >
          请填写
        </div>
      </a-radio>
    </div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import radioMixin from "../../field/new-fields/radio";
export default {
  name: "sk-radio",
  mixins: [radioMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
.otherInput:disabled {
  cursor: not-allowed;
  background-color: #e8e8e8;
  color: #999;
}
</style>
